import { createAction } from '@reduxjs/toolkit'

import type {
  LibraryInvalidatePayload,
  LibraryKindPayload,
  RemoveLibrarySymbolPayload,
  UpdateLibrarySymbolPayload,
} from './types'

// The network side of the workspace library. The store itself is the core
// `libraryReducer`; these actions only fetch, write and notify.
export const LibrarySagaActions = {
  fetch: createAction<LibraryKindPayload>('LIBRARY_FETCH'),
  invalidate: createAction<LibraryInvalidatePayload>('LIBRARY_INVALIDATE'),
  updateSymbol: createAction<UpdateLibrarySymbolPayload>(
    'LIBRARY_UPDATE_SYMBOL'
  ),
  removeSymbol: createAction<RemoveLibrarySymbolPayload>(
    'LIBRARY_REMOVE_SYMBOL'
  ),
}
